// extracted by mini-css-extract-plugin
export default {"title":"PaymentMethodsSection_title__FyAV0","divider":"PaymentMethodsSection_divider__NEm8J","linkBlue":"PaymentMethodsSection_linkBlue__C8+RS"};